import clsx from "clsx";
import { ReactNode } from "react";

interface IMCardProps {
    children: ReactNode;
    /** Viền xanh — môn đang được chọn. */
    active?: boolean;
    /** Nền vàng — lớp hết chỗ hoặc trùng lịch (mirror `.old-row-locked` desktop). */
    locked?: boolean;
    /** Viền xanh lá — lớp đã đăng ký. */
    registered?: boolean;
    className?: string;
}

/**
 * Khung thẻ dùng chung cho bản mobile (môn / lớp tín chỉ / lớp đã ĐK).
 * Primer không có component "Card" → đây là primitive bố cục tái sử dụng.
 * Bên trong dùng `.m-card-head` / `.m-card-body` / `.m-card-foot` (xem mobile.css).
 */
const MCard = ({ children, active, locked, registered, className }: IMCardProps) => (
    <div
        className={clsx(
            "m-card",
            active && "m-card-active",
            locked && "m-card-locked",
            registered && "m-card-registered",
            className
        )}
    >
        {children}
    </div>
);

export default MCard;
